module.exports = __webpack_public_path__ + "img/users_white.473367fc.png";